<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <div class="agreement">
      <img src="https://file.meikesheji.com/main/userxieyi/1.png" width="100%">
      <img src="https://file.meikesheji.com/main/userxieyi/2.png" width="100%">
      <img src="https://file.meikesheji.com/main/userxieyi/3.png" width="100%">
      <img src="https://file.meikesheji.com/main/userxieyi/4.png" width="100%">
      <img src="https://file.meikesheji.com/main/userxieyi/5.png" width="100%">
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'useragreement',
    components: {
      Menu,
      Footer
    },
    data() {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .agreement {
    margin: 0px;
    /* padding-top: 40px; */
    width: 1200px;
    /* background-color: #eeeff0; */
    margin: 0 auto;
    border-bottom: 1px solid #eeeff0;
  }

  .agreement h3 {
    font-size: 14px;
  }

  .the-box {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    background-color: #fff;
    /* margin-top: 20px; */
    margin-bottom: 20px;
    padding: 25px;
  }

  .the-title {
    font-size: 24px;
    font-family: microsoft yahei;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
    text-align: left;
  }

  .the-content {
    text-align: left;
    color: #333;
  }

  .the-content-title {
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin: 20px 0;
  }

  .weight {
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserAgreement.vue